import { createGlobalStyle } from 'styled-components';

const GlobalCommonStylesShim = createGlobalStyle`
  body {
    /*** Inputs ***/
    .common-input {
      label {
        color: #727272;
        font-size: 16px;
      }

      div,input {
        font-size: 18px;
        border-color: #CCCCCC;
        border-radius: 1rem;

        /* Errors */
        :has(+ div[role="alert"]) {
          ,div {
            border-color: red;
            border-width: 2px;
          }
        }
        [role="alert"] {
          font-size: 14px;
        }
      }

      /* Links */
      a {
        font-size: 18px;
        color: #0F5EEA;
        text-decoration: none;
      }

      /* Show password icon */
      button svg {
        transform: scale(-2.2,2);
        margin-right: 12px;
      }

      /* Checkbox unchecked */
      input ~ svg {
        fill: #CCCCCC;
      }
      /* Checkbox checked */
      input:checked + svg {
        fill: #0F5EEA;
      }
    }

    /*** Phone input - prevent iOS Safari auto-zoom (triggered when font-size < 16px) ***/
    .common-input .react-tel-input input.form-control {
      font-size: 16px;
    }

    /*** Buttons ***/
    .common-button {
      border-radius: 10px;
      font-size: 16px;
    }
    .common-button.primary {
      background-color: black;
    }
    .common-button:disabled {
      background-color: #CCCCCC;
      color: darkslategrey;
      font-style: italic;
    }
  }`;

export default GlobalCommonStylesShim;
